import {getMethod} from '@/api'

export const get = async () => await getMethod('/api/channelManagers')
